import { DropdownWithQuery } from "./dropdown/DropdownWithQuery";

export const GrowingDropdown = () => {
  return (
    <DropdownWithQuery
      query={"trend"}
      label={""}
      items={["Top Growing", "Top Falling"]}
      placeholder={"Trend Shift"}
    />
  );
};
